import React from 'react';
import { Control, UseFormSetValue, UseFormWatch, FieldErrors } from 'react-hook-form';
import { HiringFieldset, ResponsibilitiesFieldset, BenefitsFieldset } from '@/features/Collaborators/Edit/Form/Fieldsets';
import { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';
import { CollaboratorFormContext } from "@/features/Collaborators/Edit/Contexts/CollaboratorFormContext";

interface HiringTabProps {
    context: CollaboratorFormContext;
    collaboratorId: string;
    control: Control<CollaboratorFormData>;
    setValue: UseFormSetValue<CollaboratorFormData>;
    watch: UseFormWatch<CollaboratorFormData>;
    errors: FieldErrors<CollaboratorFormData>;
    isSubmitting?: boolean;
}

const HiringTab: React.FC<HiringTabProps> = ({
    context,
    collaboratorId,
    control,
    setValue,
    watch,
    errors,
    isSubmitting = false
}) => {
    return (
        <div className="space-y-6">
            <HiringFieldset
                context={context}
                collaboratorId={collaboratorId}
                control={control}
                setValue={setValue}
                watch={watch}
                errors={errors}
                isSubmitting={isSubmitting}
            />

            <ResponsibilitiesFieldset
                context={context}
                control={control}
                setValue={setValue}
                watch={watch}
                errors={errors}
                isSubmitting={isSubmitting}
            />

            <BenefitsFieldset
                context={context}
                control={control}
                setValue={setValue}
                watch={watch}
                errors={errors}
                isSubmitting={isSubmitting}
            />
        </div>
    );
};

export default HiringTab;
